// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import theme from '../../styled-components/dark';

const Wrapper = styled.div`
  display: inline-block;
  border: 1px solid ${theme.History.betslip.system.borderColor};
  color: ${theme.History.betslip.system.color};
  border-radius: 12px;
  font-size: 0.8em;
  padding: 0.25em 0.84em;
  white-space: nowrap;
  margin-right: 0.3em;
  user-select: none;

  :last-child {
    margin-right: 0;
  }
`;

type HistoryItemSystemCombinationProps = {
  label: string;
};

const HistoryItemSystemCombination = ({ label }: HistoryItemSystemCombinationProps) => {
  return <Wrapper>{label}</Wrapper>;
};

export default HistoryItemSystemCombination;
